function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.pending0{fill:#FFFFFF;}\r\n\t.pending1{fill:#66C5E9;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2_1_"
}, /*#__PURE__*/React.createElement("path", {
  className: "pending0",
  d: "M392.5,55.5h4.2c7,0,9.7-9.4,9.7-16v-26c0-6.6-5.7-12-12.7-12H13.8c-7,0-12.7,5.4-12.7,12v24 c0,6.6,2.7,16,9.7,16H15c1.7,73.2,27.2,167.7,111.6,213.6C58.6,302.9,14,389.9,14,481.5h-2.2c-7,0-10.7,5.4-10.7,12v28 c0,6.6,5.7,12,12.7,12h379.9c7,0,12.7-5.4,12.7-12v-28c0-6.6-3.7-12-10.7-12h-4.2c0-91.8-40.8-177.6-115.9-213.8 C357.8,222.2,389.5,139.4,392.5,55.5z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1_1_"
}, /*#__PURE__*/React.createElement("path", {
  className: "pending1",
  d: "M379.4,44h4c6.6,0,12-5.4,12-12v-8c0-6.6-5.4-12-12-12h-360c-6.6,0-12,5.4-12,12v8c0,6.6,5.4,12,12,12h4 c0,91.8,44.1,193.7,129.6,224C71.3,298.4,27.4,400.4,27.4,492h-4c-6.6,0-12,5.4-12,12v8c0,6.6,5.4,12,12,12h360c6.6,0,12-5.4,12-12 v-8c0-6.6-5.4-12-12-12h-4c0-91.8-44.1-193.7-129.6-224C335.6,237.5,379.4,135.5,379.4,44z M59.4,44h288c0,110.5-64.5,200-144,200 S59.4,154.4,59.4,44z M347.4,492h-288c0-110.5,64.5-200,144-200S347.4,381.5,347.4,492z M281.1,158.9c-2.1,3-4.4,5.9-6.8,8.7 c-2.3,2.7-5.7,4.3-9.2,4.3H141.8c-3.6,0-6.9-1.6-9.2-4.3c-2.4-2.8-4.6-5.7-6.8-8.7c-5.7-7.9,0.1-18.9,9.8-18.9h135.7 C281,140,286.8,151,281.1,158.9L281.1,158.9z M109.8,428H297c5.4,0,10.2,3.7,11.6,8.9c0.7,2.8,1.4,5.6,2.1,8.4 c1.7,7.5-4,14.7-11.7,14.7H107.9c-7.7,0-13.4-7.1-11.7-14.7c0.6-2.8,1.3-5.6,2.1-8.4C99.6,431.6,104.4,428,109.8,428z"
}));

const SvgIconPending = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 407.8 534.3",
    style: {
      enableBackground: "new 0 0 407.8 534.3"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPending, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-pending.48292dc5.svg";
export { ForwardRef as ReactComponent };